export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8629.6af43072.jpg";